<template>
  <v-dialog
    :value="open"
    max-width="600px"
    @click:outside="cancel"
  >
    <v-card>
      <v-card-text class="pb-0">
        <v-container class="pb-0">
          <h1 class="mb-2 mt-1">{{ $t('login.firstTime') }}</h1>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newPassword"
                outlined
                :label="$t('login.newPassword')"
                :rules="[
                  rules.required,
                  rules.charactersCount,
                  rules.containsUpperCase,
                  rules.containsNumber,
                  rules.containsLowerCase,
                  rules.containsSpecialCharacter,
                ]"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="newPasswordValidation"
                outlined
                :label="$t('login.newPasswordValidation')"
                :rules="[
                  rules.required,
                  rules.charactersCount,
                  rules.containsUpperCase,
                  rules.containsNumber,
                  rules.containsLowerCase,
                  rules.containsSpecialCharacter,
                  passwordsMatch(newPassword, newPasswordValidation),
                ]"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="ma-auto">
          <v-btn
            color="primary"
            tile
            @click="setNewPassword"
            class="mx-1"
            :disabled="!isPasswordValid(newPassword)"
            :loading="loading"
          >
            {{ $t('login.newPasswordValidation') }}
            <template v-slot:loader>
              <span class="rai-custom-loader__button">
                <v-icon dark>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Auth } from '@aws-amplify/auth';

export default {
  name: 'SetNewPasswordDialog',

  data () {
    return {
      newPassword: '',
      newPasswordValidation: '',
      showPassword: false,
      rules: {
        required: value => !!value || this.$i18n.t('login.rules.required'),
        charactersCount: value => {
          return value.length >= 8 || this.$i18n.t('login.rules.8Caracters');
        },
        containsLowerCase: value => {
          const regexp = /(?=.*[a-z])/;
          return regexp.test(value) || this.$i18n.t('login.rules.lowerCase');
        },
        containsNumber: value => {
          const regexp = /(?=.*[0-9])/;
          return regexp.test(value) || this.$i18n.t('login.rules.number');
        },
        containsUpperCase: value => {
          const regexp = /(?=.*[A-Z])/;
          return regexp.test(value) || this.$i18n.t('login.rules.upperCase');
        },
        containsSpecialCharacter: value => {
          const regexp = /(?=.*[-+_!@#$%^&*.,?])/;
          return regexp.test(value) || this.$i18n.t('login.rules.specialCaracter');
        },
      },
      loading: false,
    }
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    }
  },

  methods: {
    setNewPassword () {
      this.loading = true;
      Auth.completeNewPassword(
        this.user,
        this.newPassword,
      ).then(user => {
        this.$store.dispatch('loadCognitoUser', user.signInUserSession.idToken.payload);
        this.$router.push({ name: 'dashboard' });
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        this.loading = false;
      });
    },

    isPasswordValid (password) {
      return (this.passwordsMatch(this.newPassword, this.newPasswordValidation) === true &&
        this.rules.charactersCount(password) === true &&
        this.rules.containsLowerCase(password) === true &&
        this.rules.containsUpperCase(password) === true &&
        this.rules.containsNumber(password) === true &&
        this.rules.containsSpecialCharacter(password) === true);
    },

    passwordsMatch (pass, passConfirmation) {
      return pass === passConfirmation || this.$t('login.rules.passwordsCoincide');
    },

    cancel () {
      this.$emit('cancel');
    },
  },
};
</script>